import { defineMessages } from 'react-intl';

export default defineMessages({
  interest: 'Interest (APY)',
  interestRateType: 'Interest rate type',
  stable: 'Stable',
  variable: 'Variable',
});
